import { FC } from 'react';
import { FeatureContainer } from 'mod/featureV2/FeatureContainer';
import { IFeatureBase, IFeatureProps } from 'mod/featureV2/interface';

export const FeatureTitles: FC<IFeatureProps<IFeatureBase>> = props => {
    const {
        title,
        subtitle,
        description,
    } = props.feature;

    return !subtitle && !title && !description ? null : <FeatureContainer {...props}/>
};